import produce from 'immer';
import { NFT_REPAIR_LOG_LIST_REQUEST } from '../../constants/log/nftRepairLogConstants';

const initialState = {

};

const nftRepairLogReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case NFT_REPAIR_LOG_LIST_REQUEST:
    break;
    default:
      break;
  }
});

export default nftRepairLogReducer;
